/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SearchDollarRegularAi from './search-dollar-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SearchDollarRegularAi {...validProps} />;
}
SvgComponent.iconName = 'searchDollarRegularAi';

export const SearchDollarRegularAiIcon = svgIconWrapper(SvgComponent);
